export const COOKIES = {
  RETURN_TO: "return_to",
  SITE_BANNER: "siteBanner",
  GLOBAL_PROMO_BANNER: "global_promo_banner",
  TOKEN: "token",
  RECAPTCHA_SITE_KEY: "recaptcha_site_key",
  _GRECAPTCHA: "_GRECAPTCHA",
  SARDINE_CLIENT_ID: "sardine_client_ID",
  X_SESSION: "X-Session",
  USER_UUID: "user_uuid",
  DECAGON_OPEN: "decagon_open",
  NODE_ENV: "NODE_ENV",
  PATCH_TOKEN: "patch_token",
  COUPON_TRADE_SESSION: "_coupontrade_session",
  VDCK2: "vdck2",
  SPK: "spk",
  REACT_APP_ZENDESK_WIDGET_KEY: "zendesk_widget_key",
  REACT_APP_ZENDESK_AUTH_KEY_ID: "zendesk_auth_key_id",
  REACT_APP_ZENDESK_AUTH_KEY_SECRET: "zendesk_auth_key_secret"
};
